import React, { Component } from "react";

export default class ApplicationImg extends Component {
  render() {
    const { theme, ...svgProps } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" {...svgProps}>
    <g id="freepik--background-complete--inject-1287">
      <path
        d="M351.29,355.61a33,33,0,0,1,7.74-4.07l1.06-8,13.35-1.22,2.5,7.7a33,33,0,0,1,8.35,2.59l6.43-4.93,10.3,8.58-3.67,7.21a32.92,32.92,0,0,1,4.06,7.74l8,1.06,1.23,13.35L403,388.1a32.62,32.62,0,0,1-2.59,8.34l4.93,6.43-8.58,10.3-7.21-3.67a32.92,32.92,0,0,1-7.74,4.06l-1.06,8-13.35,1.23-2.5-7.71a32.69,32.69,0,0,1-8.35-2.59l-6.43,4.93-10.3-8.58,3.68-7.21a32.59,32.59,0,0,1-4.07-7.74l-8-1.06-1.22-13.35,7.7-2.5a33.09,33.09,0,0,1,2.59-8.35l-4.93-6.43,8.58-10.3,7.21,3.68Zm8.45,17.28A14.38,14.38,0,1,0,380,371,14.38,14.38,0,0,0,359.74,372.89Z"
        style={{
          fill: "#ebebeb",
        }}
      />
      <path
        d="M430.51,399.44a21.24,21.24,0,0,1,4.85-2.55l.67-5,8.37-.77,1.57,4.83a20.08,20.08,0,0,1,5.23,1.63l4-3.09,6.46,5.37-2.3,4.53a20.42,20.42,0,0,1,2.54,4.85l5,.66.77,8.37-4.83,1.57a20.87,20.87,0,0,1-1.63,5.23l3.09,4L459,435.53l-4.53-2.3a20.83,20.83,0,0,1-4.85,2.55l-.66,5-8.37.77L439,436.75a20.08,20.08,0,0,1-5.23-1.63l-4,3.09-6.46-5.37,2.3-4.53a20.46,20.46,0,0,1-2.55-4.85l-5-.66-.77-8.37,4.83-1.57a20.44,20.44,0,0,1,1.62-5.23l-3.09-4,5.38-6.46,4.52,2.3Zm5.3,10.84a9,9,0,1,0,12.69-1.17A9,9,0,0,0,435.81,410.28Z"
        style={{
          fill: "#ebebeb",
        }}
      />
      <path
        d="M201.18,97.84a23.9,23.9,0,0,1,5.63-3l.78-5.85,9.71-.89,1.82,5.61a24.17,24.17,0,0,1,6.08,1.88l4.68-3.58,7.5,6.24-2.68,5.25a23.7,23.7,0,0,1,3,5.63l5.84.77.9,9.72-5.61,1.82a23.8,23.8,0,0,1-1.89,6.08l3.59,4.67-6.24,7.5L229,137.06a24.27,24.27,0,0,1-5.63,3l-.78,5.84-9.71.89-1.82-5.61a23.77,23.77,0,0,1-6.08-1.88l-4.68,3.59-7.5-6.25,2.68-5.25a23.51,23.51,0,0,1-3-5.63l-5.85-.77-.89-9.71,5.61-1.83a23.73,23.73,0,0,1,1.89-6.07l-3.59-4.68,6.24-7.5,5.25,2.68Zm6.15,12.57a10.47,10.47,0,1,0,14.74-1.35A10.47,10.47,0,0,0,207.33,110.41Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M385.1,38.27a23.84,23.84,0,0,1,5.6-3l.77-5.82,9.67-.88L403,34.2A23.56,23.56,0,0,1,409,36.08l4.65-3.57,7.47,6.21-2.67,5.22a23.54,23.54,0,0,1,2.95,5.61l5.82.77L428.1,60l-5.58,1.81a23.56,23.56,0,0,1-1.88,6l3.57,4.65L418,80l-5.22-2.67a23.91,23.91,0,0,1-5.61,3l-.77,5.81-9.66.89-1.82-5.58a23.49,23.49,0,0,1-6-1.88l-4.66,3.57-7.46-6.21,2.66-5.22A23.91,23.91,0,0,1,376.47,66l-5.81-.77-.89-9.67,5.58-1.81a24,24,0,0,1,1.88-6.05l-3.57-4.65,6.21-7.47,5.23,2.67Zm6.11,12.51a10.42,10.42,0,1,0,14.67-1.34A10.41,10.41,0,0,0,391.21,50.78Z"
        style={{
          fill: "#f5f5f5",
        }}
      />
      <path
        d="M474.42,51.82a13.54,13.54,0,0,1,3.19-1.68l.44-3.31,5.5-.5,1,3.17A13.84,13.84,0,0,1,488,50.57l2.65-2,4.24,3.53-1.51,3a13.88,13.88,0,0,1,1.67,3.19l3.31.44.51,5.5-3.18,1a13.32,13.32,0,0,1-1.07,3.44l2,2.65-3.53,4.24-3-1.51A13.5,13.5,0,0,1,487,75.69L486.54,79l-5.5.51-1-3.18a13.82,13.82,0,0,1-3.44-1.06l-2.65,2-4.24-3.54,1.51-3a13.68,13.68,0,0,1-1.67-3.19l-3.31-.43-.5-5.5,3.17-1A13.44,13.44,0,0,1,470,57.19l-2-2.64,3.53-4.25,3,1.52Zm3.48,7.11a5.93,5.93,0,1,0,8.35-.76A5.93,5.93,0,0,0,477.9,58.93Z"
        style={{
          fill: "#f5f5f5",
        }}
      />
      <path
        d="M149,210.15a22.1,22.1,0,0,1,5.2-2.73l.71-5.39,9-.82,1.68,5.17a21.76,21.76,0,0,1,5.6,1.74l4.32-3.31,6.91,5.75-2.47,4.85a21.5,21.5,0,0,1,2.73,5.19l5.39.71.83,9L183.63,232a22.2,22.2,0,0,1-1.73,5.61l3.3,4.31-5.75,6.92-4.85-2.47a22.23,22.23,0,0,1-5.19,2.73l-.71,5.39-9,.82-1.68-5.17a22,22,0,0,1-5.6-1.74l-4.32,3.31-6.91-5.76,2.46-4.84a22.23,22.23,0,0,1-2.73-5.19l-5.39-.72-.82-9,5.17-1.68a22.57,22.57,0,0,1,1.74-5.6l-3.3-4.31,5.75-6.92,4.84,2.47Zm5.67,11.59a9.65,9.65,0,1,0,13.59-1.24A9.66,9.66,0,0,0,154.62,221.74Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M73.76,138.14H38.44A4.41,4.41,0,0,1,34,133.73V84.85a4.42,4.42,0,0,1,4.42-4.42h22.4L78.17,98.3v35.43A4.4,4.4,0,0,1,73.76,138.14Z"
        style={{
          fill: "#ebebeb",
        }}
      />
      <path
        d="M34,120.63H78.17a0,0,0,0,1,0,0v11.79a5.72,5.72,0,0,1-5.72,5.72H39.75A5.72,5.72,0,0,1,34,132.42V120.63A0,0,0,0,1,34,120.63Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M49.67,131.93l1.11-1.33a2,2,0,0,0,1.61,1c.8,0,1.22-.49,1.22-1.44V126h-3v-1.6h5V130c0,2.14-1.08,3.19-3.11,3.19A3.5,3.5,0,0,1,49.67,131.93Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M56.79,132.42l.64-1.38a4.61,4.61,0,0,0,2.31.64c.89,0,1.22-.23,1.22-.6,0-1.09-4,0-4-2.63,0-1.26,1.14-2.15,3.08-2.15a5.45,5.45,0,0,1,2.55.58l-.64,1.37a3.83,3.83,0,0,0-1.91-.49c-.87,0-1.24.27-1.24.61,0,1.14,4,0,4,2.66,0,1.23-1.15,2.11-3.13,2.11A5.68,5.68,0,0,1,56.79,132.42Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M43.38,111.44l1.38-1.62a4.17,4.17,0,0,0,3.49,2c1.88,0,2.86-1.15,2.86-3.39V99h-6V97h8.4v11.34c0,3.72-1.81,5.56-5.22,5.56A5.82,5.82,0,0,1,43.38,111.44Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M56.41,112.32l1-1.81a8.14,8.14,0,0,0,4.44,1.31c2.12,0,3-.64,3-1.72,0-2.84-8-.38-8-5.41,0-2.27,2-3.8,5.27-3.8A9.18,9.18,0,0,1,66.7,102l-1,1.81a6.59,6.59,0,0,0-3.65-1c-2,0-3,.74-3,1.74,0,3,8,.55,8,5.47,0,2.29-2.1,3.74-5.47,3.74A9.11,9.11,0,0,1,56.41,112.32Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path
          d="M60.84,80.43V94.19A4.11,4.11,0,0,0,65,98.29H78.17Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M61,95.39a4.57,4.57,0,0,0,3.62,4.44,3.43,3.43,0,0,0,.44.09c1.73.31,13.09,2.33,13.09,2.07V98.3H65S61.64,98.18,61,95.39Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M134.89,109.66H91.26a5.46,5.46,0,0,1-5.46-5.46V43.81a5.46,5.46,0,0,1,5.46-5.46h27.67l21.41,22.08V104.2A5.46,5.46,0,0,1,134.89,109.66Z"
        style={{
          fill: "#ebebeb",
        }}
      />
      <path
        d="M87,88h52.07a1.24,1.24,0,0,1,1.24,1.24v13.92a6.48,6.48,0,0,1-6.48,6.48H92.28a6.48,6.48,0,0,1-6.48-6.48V89.26A1.24,1.24,0,0,1,87,88Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M118.93,38.35v17A5.08,5.08,0,0,0,124,60.43h16.34Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M119.15,56.84a5.64,5.64,0,0,0,4.48,5.48,4.54,4.54,0,0,0,.53.12c2.14.38,16.18,2.88,16.18,2.56V60.43H124S119.92,60.29,119.15,56.84Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M101.41,97.45a4.67,4.67,0,0,1,8.1-2.88l-1.26,1.16a2.72,2.72,0,0,0-2.13-1,2.72,2.72,0,1,0,0,5.43,2.72,2.72,0,0,0,2.13-1l1.26,1.16a4.66,4.66,0,0,1-8.1-2.87Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M110.09,100.85l.66-1.47a5,5,0,0,0,2.8.88c1.17,0,1.64-.39,1.64-.91,0-1.59-4.93-.49-4.93-3.65,0-1.44,1.16-2.64,3.57-2.64a5.77,5.77,0,0,1,3,.75l-.61,1.49a4.88,4.88,0,0,0-2.35-.66c-1.16,0-1.61.43-1.61,1,0,1.56,4.93.48,4.93,3.6,0,1.41-1.18,2.63-3.6,2.63A6,6,0,0,1,110.09,100.85Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M117.81,100.85l.67-1.47a5,5,0,0,0,2.8.88c1.16,0,1.64-.39,1.64-.91,0-1.59-4.94-.49-4.94-3.65,0-1.44,1.17-2.64,3.58-2.64a5.71,5.71,0,0,1,2.94.75l-.6,1.49a4.88,4.88,0,0,0-2.35-.66c-1.17,0-1.62.43-1.62,1,0,1.56,4.94.48,4.94,3.6,0,1.41-1.18,2.63-3.6,2.63A6,6,0,0,1,117.81,100.85Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M104.18,70c.9.28,1.31.84,1.31,2.19V75.3a1.28,1.28,0,0,0,1.42,1.44h.35v2.37h-1.13c-2.43,0-3.68-1.24-3.68-3.48V72.1a.8.8,0,0,0-.86-.92H101V68.81h.64a.8.8,0,0,0,.86-.92V64.36c0-2.24,1.25-3.49,3.68-3.49h1.13v2.38h-.35a1.28,1.28,0,0,0-1.42,1.44v3.12C105.49,69.16,105.08,69.72,104.18,70Z"
        style={{
          fill: "#fafafa",
        }}
      />
      <path
        d="M125.19,68.81v2.37h-.64a.8.8,0,0,0-.86.92v3.53c0,2.24-1.24,3.48-3.68,3.48h-1.13V76.74h.35a1.28,1.28,0,0,0,1.42-1.44V72.18c0-1.35.41-1.91,1.31-2.19-.9-.27-1.31-.83-1.31-2.18V64.69a1.28,1.28,0,0,0-1.42-1.44h-.35V60.87H120c2.44,0,3.68,1.25,3.68,3.49v3.53a.8.8,0,0,0,.86.92Z"
        style={{
          fill: "#fafafa",
        }}
      />
    </g>
    <g id="freepik--Floor--inject-1287">
      <path
        d="M723.68,462.45c0,.15-156.12.26-348.66.26s-348.7-.11-348.7-.26,156.09-.26,348.7-.26S723.68,462.31,723.68,462.45Z"
        style={{
          fill: theme.text,
        }}
      />
    </g>
    <g id="freepik--tab-2--inject-1287">
      <rect
        x={549.21}
        y={55.51}
        width={171.88}
        height={236.32}
        rx={10.09}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={614.26}
        y={185.85}
        width={41.78}
        height={34.87}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={667.12}
        y={186.29}
        width={41.78}
        height={34.87}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={561.41}
        y={186.29}
        width={41.78}
        height={34.87}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={549.21}
        y={105.7}
        width={171.88}
        height={63.73}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M558.49,55.51h152.2a10.4,10.4,0,0,1,10.4,10.4V79.1a0,0,0,0,1,0,0H549.21a0,0,0,0,1,0,0V64.78A9.28,9.28,0,0,1,558.49,55.51Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M573.1,92.4a7.49,7.49,0,1,1-7.48-7.48A7.48,7.48,0,0,1,573.1,92.4Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <rect
        x={612.85}
        y={89.08}
        width={27.49}
        height={6.41}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={647.12}
        y={89.08}
        width={27.49}
        height={6.41}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={681.38}
        y={89.08}
        width={27.49}
        height={6.41}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={561.41}
        y={232.95}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={561.41}
        y={245.14}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={561.41}
        y={257.33}
        width={22.62}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={615.11}
        y={232.95}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={615.11}
        y={245.14}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={615.11}
        y={257.33}
        width={22.62}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={668.82}
        y={232.95}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={668.82}
        y={245.14}
        width={41.78}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={668.82}
        y={257.33}
        width={22.62}
        height={5.58}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M711,291.82l.52,0a11.08,11.08,0,0,0,1.53-.19,10.34,10.34,0,0,0,5.18-2.9,10.07,10.07,0,0,0,2.27-3.77,15,15,0,0,0,.52-5.31c0-3.89,0-8.38,0-13.43,0-20.23,0-49.48-.08-85.62,0-18.08,0-37.88,0-59.13q0-15.95,0-32.94,0-8.49,0-17.23V66.88a12.59,12.59,0,0,0-.47-4.29,9.93,9.93,0,0,0-5.75-6.14,10.82,10.82,0,0,0-4.31-.7h-151a9.82,9.82,0,0,0-8.39,4.69,9.69,9.69,0,0,0-1.43,4.73c0,1.69,0,3.41,0,5.1v60c0,26,0,51.1,0,75s0,46.61,0,67.87V281a10.11,10.11,0,0,0,2.32,7.06,9.89,9.89,0,0,0,6.42,3.45c1.22.11,2.49.05,3.73.07h3.72l28.37,0,85.62.08,23.28,0,6.05,0,2.06,0-2.06,0-6.05,0-23.28.05L594,292H561.9c-1.25,0-2.48.05-3.77-.07a10.21,10.21,0,0,1-6.69-3.58A10.58,10.58,0,0,1,549,281v-7.9c0-21.26,0-44,0-67.87s0-49,0-75V90.59q0-10.08,0-20.3c0-1.7,0-3.39,0-5.12a10.11,10.11,0,0,1,1.51-5,10.33,10.33,0,0,1,8.83-4.94h151a11.16,11.16,0,0,1,4.49.73,10.4,10.4,0,0,1,6,6.45,12.64,12.64,0,0,1,.49,4.43v4.38q0,8.73,0,17.23,0,17,0,32.94c0,21.25,0,41,0,59.13,0,36.14-.06,65.39-.08,85.62,0,5.05,0,9.54,0,13.43,0,1,0,1.91,0,2.81a9.7,9.7,0,0,1-.5,2.54,10.14,10.14,0,0,1-7.57,6.68,10.66,10.66,0,0,1-1.54.17Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M566,68.54a2.86,2.86,0,1,1-2.86-2.86A2.86,2.86,0,0,1,566,68.54Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M575.06,68.54a2.87,2.87,0,1,1-2.87-2.86A2.87,2.87,0,0,1,575.06,68.54Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M584.11,68.54a2.87,2.87,0,1,1-2.87-2.86A2.86,2.86,0,0,1,584.11,68.54Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M623.25,138.87v-14a3.51,3.51,0,0,1,5.26-3l12.46,7,12.46,7a3.36,3.36,0,0,1,0,5.9l-12.46,7-12.46,7a3.51,3.51,0,0,1-5.26-2.95Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
    <g id="freepik--tab-1--inject-1287">
      <path
        d="M171.77,125.83H514.61a9.7,9.7,0,0,1,9.7,9.7V361.8a12.37,12.37,0,0,1-12.37,12.37H171.23a9.15,9.15,0,0,1-9.15-9.15V135.53A9.7,9.7,0,0,1,171.77,125.83Z"
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={208.32}
        y={161.45}
        width={25.55}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={208.32}
        y={186.4}
        width={12.77}
        height={5.57}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <rect
        x={217.93}
        y={198.95}
        width={17.99}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={238.78}
        y={198.95}
        width={10.48}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={321.67}
        y={198.95}
        width={21.55}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={369.81}
        y={211.18}
        width={36.41}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={444.91}
        y={198.95}
        width={17.49}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={467.76}
        y={198.95}
        width={35.16}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={217.93}
        y={211.18}
        width={17.99}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={206.88}
        y={223.38}
        width={17.99}
        height={5.57}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <rect
        x={216.46}
        y={235.59}
        width={8.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={247.31}
        y={261.29}
        width={8.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={362.91}
        y={307.74}
        width={16.42}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={430.84}
        y={307.74}
        width={40.23}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={301.09}
        y={295.55}
        width={16.42}
        height={5.57}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={241.6}
        y={285.08}
        width={16.42}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={333.62}
        y={307.74}
        width={25.89}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={216.46}
        y={248.02}
        width={13.64}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={216.46}
        y={261.5}
        width={25.3}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={216.46}
        y={271.83}
        width={37.01}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={283.52}
        y={271.83}
        width={37.01}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={241.27}
        y={295.55}
        width={51.97}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={241.27}
        y={307.74}
        width={87.9}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={214.68}
        y={319.93}
        width={87.9}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={257.38}
        y={271.83}
        width={22.2}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={228.18}
        y={235.59}
        width={22.91}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={233.23}
        y={248.02}
        width={22.91}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={284.24}
        y={248.02}
        width={60.67}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={346.56}
        y={248.02}
        width={70.07}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={259.91}
        y={248.02}
        width={18.96}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={254.23}
        y={235.59}
        width={30.03}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={287.58}
        y={235.59}
        width={16.72}
        height={5.57}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={238.78}
        y={211.18}
        width={18.75}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={270.27}
        y={211.18}
        width={92.59}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={423.02}
        y={248.02}
        width={43.78}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={383.6}
        y={307.74}
        width={43.78}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={346.89}
        y={198.95}
        width={91.21}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={252.53}
        y={198.95}
        width={63.47}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={208.32}
        y={173.26}
        width={42.73}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={255.31}
        y={173.26}
        width={58.51}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={237.85}
        y={161.45}
        width={18.81}
        height={5.57}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={183.42}
        y={161.45}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={173.64}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={185.83}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={198.02}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={210.21}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={222.4}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={234.59}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={246.78}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={258.97}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={245.25}
        y={346.26}
        width={8.4}
        height={5.57}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <rect
        x={214.84}
        y={346.26}
        width={25.3}
        height={5.57}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <rect
        x={183.42}
        y={345.64}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={271.16}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={283.35}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={295.55}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={307.74}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={319.93}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={214.68}
        y={332.76}
        width={25.63}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={245.25}
        y={332.76}
        width={57.97}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={183.42}
        y={332.76}
        width={5.4}
        height={5.57}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <rect
        x={320.97}
        y={173.22}
        width={18.81}
        height={5.57}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <circle
        cx={182.29}
        cy={141.89}
        r={3.83}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <circle
        cx={192.91}
        cy={141.89}
        r={3.83}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <circle
        cx={203.53}
        cy={141.89}
        r={3.83}
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <rect x={348.86} y={274.61} width={150.86} height={86.46} rx={7.24} />
      </g>
      <rect
        x={359.51}
        y={265.37}
        width={150.86}
        height={86.46}
        rx={4.44}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M418.62,319.17H404.84l-2.56,6.33h-9.4l14.38-32.58h9.08l14.42,32.58h-9.58Zm-2.7-6.79L411.73,302l-4.19,10.43Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M455.94,294.39a11.4,11.4,0,0,1,5,4.19,11.55,11.55,0,0,1,1.76,6.4,11,11,0,0,1-6.79,10.54,18.69,18.69,0,0,1-7.68,1.46h-5.68v8.52h-9.21V292.92h14.89A18.53,18.53,0,0,1,455.94,294.39Zm-4,14.1a4.37,4.37,0,0,0,1.45-3.51,4.46,4.46,0,0,0-1.45-3.54,6.34,6.34,0,0,0-4.28-1.26h-5.12v9.54h5.12A6.45,6.45,0,0,0,452,308.49Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M467.2,292.92h9.22V325.5H467.2Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M198.35,159.86c.14,0,.26,47.95.26,107.1s-.12,107.11-.26,107.11-.26-47.95-.26-107.11S198.2,159.86,198.35,159.86Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
    </g>
    <g id="freepik--line-2--inject-1287">
      <path
        d="M594.22,360.11a4.87,4.87,0,1,1-4.87-4.86A4.87,4.87,0,0,1,594.22,360.11Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M617.81,338.55a4.87,4.87,0,1,1-4.87-4.87A4.87,4.87,0,0,1,617.81,338.55Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M594.69,317a4.87,4.87,0,1,1-4.87-4.86A4.86,4.86,0,0,1,594.69,317Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M612.27,338.55c0,.14-18.95.26-42.32.26s-42.32-.12-42.32-.26,18.94-.26,42.32-.26S612.27,338.4,612.27,338.55Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M589.35,362.33c-.14,0-.26-9.95-.26-22.22s.12-22.22.26-22.22.26,9.95.26,22.22S589.5,362.33,589.35,362.33Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
    </g>
    <g id="freepik--line-1--inject-1287">
      <path
        d="M313.4,391a1.91,1.91,0,0,1,0,.42c0,.31,0,.72,0,1.25,0,1.12,0,2.73.05,4.79,0,4.2.05,10.21.08,17.64,0,3.73,0,7.81,0,12.18,0,1.1,0,2.21,0,3.34s.06,2.27-.07,3.47a9.07,9.07,0,0,1-7.13,7.73,20.86,20.86,0,0,1-3.86.19H278.09l-58.2-.08-17.64-.08-4.79-.05-1.25,0-.42,0,.42,0,1.25,0,4.79,0,17.64-.09,58.2-.07h24.47a20.19,20.19,0,0,0,3.76-.17,8.4,8.4,0,0,0,3.3-1.45,8.59,8.59,0,0,0,3.48-5.85c.12-1.12,0-2.29.07-3.42s0-2.24,0-3.34c0-4.37,0-8.45,0-12.18,0-7.43.07-13.44.09-17.64,0-2.06,0-3.67,0-4.79,0-.53,0-.94,0-1.25A2.24,2.24,0,0,1,313.4,391Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M316.88,387.52A3.49,3.49,0,1,1,313.4,384,3.49,3.49,0,0,1,316.88,387.52Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M199.38,441.22a3.49,3.49,0,1,1-3.48-3.49A3.48,3.48,0,0,1,199.38,441.22Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
    </g>
    <g id="freepik--Icon--inject-1287">
      <rect
        x={261.21}
        y={79.51}
        width={90.06}
        height={59.55}
        rx={8.38}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <rect x={261.21} y={79.51} width={90.06} height={59.55} rx={8.38} />
      </g>
      <rect
        x={255.16}
        y={79.51}
        width={90.06}
        height={59.55}
        rx={8.38}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M290.46,105.94l-12.27,4.35,12.27,4.35v5.62l-19-7v-5.92l19-7Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M304,91.36h6.5l-12.7,36.24h-6.5Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M329.86,107.33v5.92l-19,7v-5.62l12.28-4.35-12.28-4.35v-5.62Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
    <g id="freepik--Gear--inject-1287">
      <path
        d="M432.09,100.77a39.19,39.19,0,0,1,9.56-4.15l2-9.47,16-.28,2.3,9.39a38.86,38.86,0,0,1,9.7,3.82l4.44-5.3h3.64l11.51,11.11-5,8.26a38.86,38.86,0,0,1,4.15,9.56l9.46,2,.29,16L490.7,144a39.18,39.18,0,0,1-3.82,9.69l5.3,8.09-11.11,11.5h-3.64l-4.62-5a38.86,38.86,0,0,1-9.56,4.15l-2,9.47-16,.28-2.3-9.39a39,39,0,0,1-9.7-3.82l-8.08,5.3h-3.64l-7.86-11.11,5-8.26a38.89,38.89,0,0,1-4.16-9.56l-9.46-2-.28-16,9.39-2.31a39,39,0,0,1,3.81-9.7l-5.29-8.08,7.46-11.5h3.64l8.26,5Zm8.53,21.3a17.15,17.15,0,1,0,24.25-.43A17.15,17.15,0,0,0,440.62,122.07Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M432.09,100.77a39.19,39.19,0,0,1,9.56-4.15l2-9.47,16-.28,2.3,9.39a38.86,38.86,0,0,1,9.7,3.82l4.44-5.3h3.64l11.51,11.11-5,8.26a38.86,38.86,0,0,1,4.15,9.56l9.46,2,.29,16L490.7,144a39.18,39.18,0,0,1-3.82,9.69l5.3,8.09-11.11,11.5h-3.64l-4.62-5a38.86,38.86,0,0,1-9.56,4.15l-2,9.47-16,.28-2.3-9.39a39,39,0,0,1-9.7-3.82l-8.08,5.3h-3.64l-7.86-11.11,5-8.26a38.89,38.89,0,0,1-4.16-9.56l-9.46-2-.28-16,9.39-2.31a39,39,0,0,1,3.81-9.7l-5.29-8.08,7.46-11.5h3.64l8.26,5Zm8.53,21.3a17.15,17.15,0,1,0,24.25-.43A17.15,17.15,0,0,0,440.62,122.07Z" />
      </g>
      <path
        d="M428.45,100.77A38.86,38.86,0,0,1,438,96.62l2-9.47,16-.28,2.3,9.39a39,39,0,0,1,9.7,3.82l8.08-5.3,11.5,11.11-5,8.26a38.89,38.89,0,0,1,4.16,9.56l9.46,2,.28,16L487.05,144a38.77,38.77,0,0,1-3.81,9.69l5.29,8.09-11.1,11.5-8.26-5a39,39,0,0,1-9.56,4.15l-2,9.47-16,.28-2.3-9.39a38.86,38.86,0,0,1-9.7-3.82l-8.08,5.3-11.51-11.11,5-8.26a39.24,39.24,0,0,1-4.15-9.56l-9.46-2-.28-16,9.38-2.31a39.41,39.41,0,0,1,3.82-9.7l-5.3-8.08,11.11-11.5,8.26,5Zm8.52,21.3a17.15,17.15,0,1,0,24.26-.43A17.14,17.14,0,0,0,437,122.07Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
    </g>
    <g id="freepik--Device--inject-1287">
      <path
        d="M705.51,462.45l-66-.28c-7.94,0-14.34-6.13-14.31-13.61l.7-156c0-7.49,6.5-13.53,14.44-13.49l66,.28c7.93,0,14.34,6.13,14.31,13.61L720,449C719.92,456.44,713.46,462.49,705.51,462.45Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M706.25,284.76l-12.79-.06-37.37-.16-4.5,0-11.2,0c-5.56,0-10.09,4.21-10.11,9.45l-.69,152.24c0,5.24,4.47,9.51,10,9.54l65.87.28c5.56,0,10.09-4.21,10.11-9.45l.68-152.24C716.3,289.05,711.81,284.78,706.25,284.76Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M706.82,298.92a.8.8,0,0,1-.82.79.79.79,0,1,1,0-1.58A.8.8,0,0,1,706.82,298.92Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M706.81,301.77a.82.82,0,0,1-1.64,0,.82.82,0,0,1,1.64,0Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M706.8,304.62a.82.82,0,1,1-.82-.79A.8.8,0,0,1,706.8,304.62Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M650.85,302.56a5.39,5.39,0,1,1-5.39-5.23A5.32,5.32,0,0,1,650.85,302.56Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M690.89,303.57H663.26a1.8,1.8,0,0,1-1.8-1.8h0a1.8,1.8,0,0,1,1.8-1.8h27.63a1.81,1.81,0,0,1,1.8,1.8h0A1.81,1.81,0,0,1,690.89,303.57Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M656.71,370.23V354.77a3.89,3.89,0,0,1,5.83-3.27l13.79,7.73,13.8,7.73a3.72,3.72,0,0,1,0,6.53l-13.8,7.73L662.54,389a3.89,3.89,0,0,1-5.83-3.27Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
    </g>
    <g id="freepik--Cloud--inject-1287">
      <path
        d="M511,437.48c5.85-9.31,15.76-11.48,24.76-9.43A39,39,0,0,1,613,417.28c9.33-6.62,23.33-2.14,30.17,7s7.26,28.74-.75,37.95l-129.21-.74S503.35,449.55,511,437.48Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M511,437.48c5.85-9.31,15.76-11.48,24.76-9.43A39,39,0,0,1,613,417.28c9.33-6.62,23.33-2.14,30.17,7s7.26,28.74-.75,37.95l-129.21-.74S503.35,449.55,511,437.48Z" />
      </g>
      <path
        d="M499.85,437.48c5.85-9.31,15.76-11.48,24.76-9.43a39,39,0,0,1,77.27-10.77c9.33-6.62,23.33-2.14,30.17,7s7.26,28.74-.75,37.95l-129.21-.74S492.25,449.55,499.85,437.48Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
    </g>
    <g id="freepik--Character--inject-1287">
      <rect
        x={45.67}
        y={333.23}
        width={135.18}
        height={129.23}
        rx={3.87}
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M181.09,374.48c0,.14-30.2.26-67.43.26s-67.44-.12-67.44-.26,30.19-.26,67.44-.26S181.09,374.33,181.09,374.48Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M181.09,416c0,.14-30.2.26-67.43.26s-67.44-.12-67.44-.26,30.19-.26,67.44-.26S181.09,415.82,181.09,416Z"
        style={{
          fill: theme.text,
        }}
      />
      <circle
        cx={70.25}
        cy={355.04}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <circle
        cx={80.79}
        cy={355.04}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={145.76}
        y={350.51}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={152.54}
        y={350.51}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={158.79}
        y={350.51}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={138.9}
        y={350.51}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <circle
        cx={70.25}
        cy={395.34}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <circle
        cx={80.22}
        cy={395.34}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={145.76}
        y={390.82}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={152.54}
        y={390.82}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={158.79}
        y={390.82}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={138.9}
        y={390.82}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <circle
        cx={70.25}
        cy={438.73}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <circle
        cx={81.07}
        cy={438.73}
        r={2.94}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={145.76}
        y={434.21}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={152.54}
        y={434.21}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.text,
        }}
      />
      <rect
        x={158.79}
        y={434.21}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={138.9}
        y={434.21}
        width={2.69}
        height={10.01}
        rx={1.09}
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M113.06,148.54a4.37,4.37,0,0,0-5-3.76,5.61,5.61,0,0,0-7.41-2.27c-1.2.67-2.1,1.77-3.27,2.48a38.87,38.87,0,0,1-3.63,1.56,4,4,0,0,0-2.47,2.86,3.46,3.46,0,0,0,2.35,3.34,10.17,10.17,0,0,0,4.33.39,1.53,1.53,0,0,0-.44,2,3,3,0,0,0,1.68,1.35,6.66,6.66,0,0,0,6.84-1.26l2.74-2.1A4.37,4.37,0,0,0,113.06,148.54Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M106.22,157.68a1.45,1.45,0,0,1-1.93,0,2,2,0,0,1-.46-2,3,3,0,0,1,1.31-1.63,7.49,7.49,0,0,1,2-.83,14.18,14.18,0,0,1,3.23-.61,2.63,2.63,0,0,1,1.15.14,1.12,1.12,0,0,1,.7.86c0,.55-.44,1-.88,1.31a34.26,34.26,0,0,1-5.22,3.17"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M104.62,157.4c-2.59-2.89-9.05-2.5-10.59-.62a4.93,4.93,0,0,0-6.46,2.09l-6.87,1.46a7.12,7.12,0,0,0-3.31,1.3,2.47,2.47,0,0,0-.6,3.2,3.73,3.73,0,0,0-1.61,6,2.59,2.59,0,0,0,.36,3.77,25.84,25.84,0,0,0-4.48,7.61,5.29,5.29,0,0,0-.37,3.61c.42,1.17,2,2,3,1.26a3,3,0,0,0-.16,3.29c-1.16,0-1.52,1.81-.73,2.66a4.23,4.23,0,0,0,3.25.93,5.59,5.59,0,0,1,3.37.6,1.06,1.06,0,0,1-.39.73,4.78,4.78,0,0,0-1.11,6.5c.14.19.27.37.38.54a10.43,10.43,0,0,0,3.36,2.39c2.61,1.39,4.18,1.14,7.11,1.58-.82,1.89,3.91,6.11,9.39,2a105,105,0,0,0,29.94,4.27c1.6,0,3.53-.18,4.26-1.62a4,4,0,0,0,3.67-1.18,11.53,11.53,0,0,0,2.18-3.38,7,7,0,0,0,5.08-6.26,8.66,8.66,0,0,0,3.31-6.13,5.08,5.08,0,0,0,3-6.83,30.54,30.54,0,0,0-3.28-9.5c1.85-.39,2.56-2.87,1.81-4.6s-2.41-2.85-4-3.87c1.37.38,2.58-1.34,2.27-2.73a5.44,5.44,0,0,0-2.78-3.1,25.37,25.37,0,0,0-5.69-2.58c-.63-2.43-3.71-5.21-6-6.3-9.13-4.4-15.53-5.54-27.26,2.92"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M97.57,172.09c-.12-1.93-.44-3.83,1.46-4.12l19.46-5.87c6.27-.95,10.81,6.62,11.5,12.93.76,7,1.41,15.59.82,20.87a16.06,16.06,0,0,1-10.56,13.47l.25,6.44c-.81,5-2.07,10.53-4.08,12.52-6.88-1.29-18.14-16.42-18.14-16.42Z"
        style={{
          fill: "#ae7461",
        }}
      />
      <path
        d="M119.8,191.05a9.75,9.75,0,0,1,2.35-.53c.37-.05.72-.14.77-.4a1.94,1.94,0,0,0-.3-1.09l-1.23-2.78c-1.7-4-3-7.22-2.8-7.29s1.68,3.09,3.38,7c.42,1,.81,1.9,1.18,2.8a2.11,2.11,0,0,1,.26,1.45.94.94,0,0,1-.58.57,2.79,2.79,0,0,1-.63.11A8.84,8.84,0,0,1,119.8,191.05Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M120.25,209.37a34.88,34.88,0,0,1-13-4.27s2.44,6.65,13,7.46Z"
        style={{
          fill: "#6f4439",
        }}
      />
      <path
        d="M113.59,174.84c-.12.4-1.58.28-3.28.56s-3.06.81-3.3.47c-.11-.17.11-.55.65-1a5.66,5.66,0,0,1,2.42-1,5.46,5.46,0,0,1,2.6.19C113.32,174.35,113.65,174.65,113.59,174.84Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M127.59,174.6c-.24.34-1.26,0-2.47.08s-2.21.33-2.46,0c-.12-.16,0-.5.46-.83a3.55,3.55,0,0,1,4-.06C127.54,174.1,127.69,174.43,127.59,174.6Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M134.73,180.09a7.26,7.26,0,0,0-1.75-4.54,25,25,0,0,1-2-1.89c-1.19-1.55-1-3.72-1.52-5.61a8,8,0,0,0-4.94-5.36c-2-.7-4.22-.61-6.08-1.59-1.37-.73-2.42-2-3.83-2.64-2.75-1.25-5.94.16-8.54,1.71-.51,2.07.79,3.85,2,5.57a7.41,7.41,0,0,0,5.43,2.95c1.65.1,3.57-.28,4.73.9s.75,3.41,1.75,4.83c1.43,2,4.69,1.25,6.83,2.5,1.65,1,2.35,3,3.18,4.67s2.28,3.53,4.19,3.43A21.56,21.56,0,0,0,134.73,180.09Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M110.22,163.93a37.45,37.45,0,0,0-14.12,2.55,6.82,6.82,0,0,0-3.48,2.41,6.62,6.62,0,0,0-.73,3.66c0,3.95,1.64,8.78,3.15,12.43l4.93,3c3.8-.9,2-7.46,1.87-10.75a7.75,7.75,0,0,0,4.53-6.85A8.57,8.57,0,0,0,110.22,163.93Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M99.91,186.51C99.75,184.25,97,183.82,95,185c-1.07.64-1.87,1.91-1.73,4.3.37,6.4,6.72,4.71,6.72,4.52S100.08,189.16,99.91,186.51Z"
        style={{
          fill: "#ae7461",
        }}
      />
      <path
        d="M97.93,191.49s-.1.09-.29.19a1.12,1.12,0,0,1-.83.06,2.77,2.77,0,0,1-1.42-2.4,3.67,3.67,0,0,1,.22-1.61,1.3,1.3,0,0,1,.79-.91.6.6,0,0,1,.68.27c.09.18.06.31.09.31s.13-.11.07-.37a.76.76,0,0,0-.28-.39.86.86,0,0,0-.62-.12,1.57,1.57,0,0,0-1.11,1,3.84,3.84,0,0,0-.28,1.81,2.89,2.89,0,0,0,1.78,2.67,1.2,1.2,0,0,0,1-.23C97.93,191.65,98,191.5,97.93,191.49Z"
        style={{
          fill: "#6f4439",
        }}
      />
      <path
        d="M97.22,194.18s0,0,0,.09a1.53,1.53,0,0,1-.09.24,1.49,1.49,0,0,1-.74.67,4,4,0,0,1-1.58.33,5.3,5.3,0,0,1-1-.07,3.78,3.78,0,0,1-1.12-.34l.08,0a3.18,3.18,0,0,1-5.07,2l.11,0a1.28,1.28,0,0,1-.84.56,1.81,1.81,0,0,1-1-.08,1.7,1.7,0,0,1-.84-.68,2.26,2.26,0,0,1-.32-1.05,3.25,3.25,0,0,1,.69-2.14A9.73,9.73,0,0,1,87.12,192v.15a2.3,2.3,0,0,1-1-1.52,3.37,3.37,0,0,1,.18-1.88,5,5,0,0,1,1.12-1.6,15.25,15.25,0,0,1,1.51-1.28v.14a2.43,2.43,0,0,1-.63-1.85,3.47,3.47,0,0,1,.72-1.9,8.54,8.54,0,0,1,3.12-2.18l-.05.11A4.25,4.25,0,0,1,96.68,175l-.1.11a3.81,3.81,0,0,1,3.56-4.45l-.08.09a3.6,3.6,0,0,1,1.45-2.79,3.53,3.53,0,0,1,2.68-.75l-.08.07a3.46,3.46,0,0,1,.52-1.64,4.78,4.78,0,0,1,1-1.18,3.66,3.66,0,0,1,2.19-.94l.24,0,.22,0a2.48,2.48,0,0,1,.41,0,6.18,6.18,0,0,1,.61.17l.36.16.11,0s0,0-.12,0l-.36-.13c-.16-.07-.37-.09-.61-.16a2.5,2.5,0,0,0-.4,0l-.22,0-.24,0a3.62,3.62,0,0,0-2.12,1,4.15,4.15,0,0,0-.94,1.15,3.38,3.38,0,0,0-.49,1.59v.07h-.07a3.39,3.39,0,0,0-2.57.73,3.48,3.48,0,0,0-1.38,2.67v.08h-.08a3.65,3.65,0,0,0-3.38,4.25l0,.12h-.13a4.06,4.06,0,0,0-4.4,5l0,.07-.07,0a8.43,8.43,0,0,0-3,2.12,3.25,3.25,0,0,0-.68,1.8,2.19,2.19,0,0,0,.57,1.71l.08.07-.09.07a7.46,7.46,0,0,0-2.57,2.8,3.16,3.16,0,0,0-.18,1.77,2.07,2.07,0,0,0,.93,1.4l.11.07-.1.08a9.4,9.4,0,0,0-1.66,1.61,3.09,3.09,0,0,0-.66,2,1.71,1.71,0,0,0,1,1.59,1.42,1.42,0,0,0,1.7-.41l0-.07.06.05a3.06,3.06,0,0,0,4.87-1.92l0-.07.06,0a3.81,3.81,0,0,0,1.09.34,6,6,0,0,0,1,.08,4,4,0,0,0,1.56-.3,1.55,1.55,0,0,0,.74-.63A2.14,2.14,0,0,0,97.22,194.18Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M72.85,187.35a2.37,2.37,0,0,1-.24-.39,3.4,3.4,0,0,1-.34-1.27,3.17,3.17,0,0,1,.53-2,3.39,3.39,0,0,1,2.31-1.48l0,.08a4.34,4.34,0,0,1,.58-3.16,4.16,4.16,0,0,1,1.25-1.33,10.06,10.06,0,0,1,1.75-.83,3.49,3.49,0,0,0,.83-.49,2.22,2.22,0,0,0,.59-.79c.28-.61.37-1.34.73-2a3.9,3.9,0,0,1,3.9-1.93l-.11.11a5.13,5.13,0,0,1,5.67-5.82l-.11.11a4.5,4.5,0,0,1,7-4.21H97a6,6,0,0,1,2.23-1.36,8.66,8.66,0,0,1,2.3-.53,10.73,10.73,0,0,1,3.79.25,7.83,7.83,0,0,1,2.25.94,5,5,0,0,1,.52.37l.17.15s-.24-.19-.71-.48a8,8,0,0,0-2.25-.89,10.9,10.9,0,0,0-3.76-.21,9.23,9.23,0,0,0-2.26.53,6.1,6.1,0,0,0-2.17,1.35l0,0-.06,0a4.32,4.32,0,0,0-6.72,4l0,.12-.12,0a4.94,4.94,0,0,0-5.46,5.6V172l-.12,0A3.7,3.7,0,0,0,81,173.78c-.34.62-.43,1.34-.73,2a2.33,2.33,0,0,1-.63.85,4,4,0,0,1-.89.52,10.47,10.47,0,0,0-1.72.8,4.13,4.13,0,0,0-1.22,1.28,4.3,4.3,0,0,0-.58,3l0,.07h-.07a3.28,3.28,0,0,0-2.25,1.4,3.21,3.21,0,0,0-.54,1.95,3.39,3.39,0,0,0,.3,1.25C72.77,187.21,72.86,187.34,72.85,187.35Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M134,189.07a.62.62,0,0,1,0-.52,1.22,1.22,0,0,1,.37-.53,2.18,2.18,0,0,1,.79-.4,3.69,3.69,0,0,0,1-.42,2,2,0,0,0,.72-1,3.89,3.89,0,0,0,.16-1.47c0-.53-.1-1.08-.1-1.68a16.66,16.66,0,0,1,.81-3.78,5.33,5.33,0,0,0,.08-2.11,2.52,2.52,0,0,0-1.16-1.8,9.52,9.52,0,0,0-2.24-.76,3.69,3.69,0,0,1-1.14-.53,2.49,2.49,0,0,1-.81-1,12.19,12.19,0,0,1-.68-2.52,4,4,0,0,0-.44-1.21,2,2,0,0,0-.94-.83,6.87,6.87,0,0,0-1.77-.24,2.76,2.76,0,0,1-.9-.22,2,2,0,0,1-.71-.6,6.59,6.59,0,0,1-.67-1.64,4,4,0,0,0-.8-1.44,3.84,3.84,0,0,0-2.79-1.33,3.93,3.93,0,0,0-2.71,1l-.09.08,0-.11a6.09,6.09,0,0,0-3.8-3.27,5.51,5.51,0,0,0-2.14-.19,5.17,5.17,0,0,0-1.76.49,4.59,4.59,0,0,0-1.87,1.72,3.87,3.87,0,0,0-.31.6l-.08.16,0,.05a.15.15,0,0,1,0-.06l.06-.16a3.67,3.67,0,0,1,.3-.62,4.47,4.47,0,0,1,1.87-1.78,5.45,5.45,0,0,1,1.79-.52,5.9,5.9,0,0,1,2.18.17,6.24,6.24,0,0,1,3.92,3.35l-.13,0a4.13,4.13,0,0,1,2.83-1,4.1,4.1,0,0,1,3.76,2.89,6.18,6.18,0,0,0,.65,1.59,1.88,1.88,0,0,0,1.47.74,6.87,6.87,0,0,1,1.82.25,2.2,2.2,0,0,1,1,.91,4.62,4.62,0,0,1,.46,1.27,12.2,12.2,0,0,0,.66,2.48,2.39,2.39,0,0,0,.75.94,3.76,3.76,0,0,0,1.09.51,9.32,9.32,0,0,1,2.28.78,2.5,2.5,0,0,1,.84.84,3.34,3.34,0,0,1,.39,1.08,5.61,5.61,0,0,1-.09,2.17,17.43,17.43,0,0,0-.84,3.75c0,.58.08,1.14.09,1.68a3.87,3.87,0,0,1-.18,1.5,2,2,0,0,1-.77,1.07,3.63,3.63,0,0,1-1,.41,2.3,2.3,0,0,0-.77.37,1.28,1.28,0,0,0-.38.5A.82.82,0,0,0,134,189.07Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M146.45,179.16s0,0-.07-.12l-.17-.35-.66-1.39c-.29-.6-.62-1.35-1.08-2.17a5.72,5.72,0,0,0-2.15-2.3c-.51-.28-1.11-.47-1.71-.73a4.9,4.9,0,0,1-.88-.51,2.35,2.35,0,0,1-.65-.84c-.3-.66-.31-1.41-.55-2.1a1.82,1.82,0,0,0-.62-.87,3.25,3.25,0,0,0-1-.48,6.53,6.53,0,0,1-1.13-.43,2.07,2.07,0,0,1-.87-.91,9.18,9.18,0,0,1-.55-2.48,3.16,3.16,0,0,0-.42-1.17,1.63,1.63,0,0,0-1-.67c-.84-.18-1.74.12-2.68,0A2.27,2.27,0,0,1,129,161a5.61,5.61,0,0,1-.8-1.1,12.3,12.3,0,0,0-.7-1.11,2.57,2.57,0,0,0-.94-.8,3.78,3.78,0,0,0-2.42,0,5.72,5.72,0,0,1-2.43.21,6.45,6.45,0,0,1-2.11-1,11.82,11.82,0,0,0-1.88-1.05,6.69,6.69,0,0,0-3.8-.12,7.12,7.12,0,0,0-2.81,1.45,7.68,7.68,0,0,0-1.55,1.84,8.63,8.63,0,0,0-.67,1.37c-.06.16-.11.28-.15.37a1.11,1.11,0,0,1,0,.13s0-.05,0-.13.07-.22.13-.38a7.47,7.47,0,0,1,2.18-3.28,7.11,7.11,0,0,1,2.84-1.5,6.73,6.73,0,0,1,3.89.1,12,12,0,0,1,1.92,1,6.33,6.33,0,0,0,2.06.94,5.46,5.46,0,0,0,2.35-.22,8.14,8.14,0,0,1,1.25-.22,2.64,2.64,0,0,1,1.29.21,2.55,2.55,0,0,1,1,.86,11.86,11.86,0,0,1,.72,1.12,5.31,5.31,0,0,0,.77,1.06,2.09,2.09,0,0,0,1.12.6c.87.14,1.78-.15,2.69,0a1.77,1.77,0,0,1,1.13.75,3.23,3.23,0,0,1,.46,1.24,9.78,9.78,0,0,0,.52,2.44,1.89,1.89,0,0,0,.8.83,6.58,6.58,0,0,0,1.1.42,3.45,3.45,0,0,1,1.08.51,1.93,1.93,0,0,1,.67,1c.25.73.25,1.47.54,2.1a2.64,2.64,0,0,0,1.44,1.27c.59.27,1.19.46,1.72.75a5.76,5.76,0,0,1,2.17,2.36c.46.84.78,1.59,1.05,2.2l.63,1.4c.07.15.12.27.16.37Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M139.64,172.47l.12,0a.65.65,0,0,1,.34.08,1.36,1.36,0,0,1,.63,1.13,3.35,3.35,0,0,1-.13,1,3.9,3.9,0,0,0-.17,1.1,2.43,2.43,0,0,0,.45,1.18c.25.39.57.77.82,1.23a1.84,1.84,0,0,1,.16,1.61c-.2.54-.6,1-.79,1.55a2.41,2.41,0,0,0,.17,1.76c.25.59.61,1.15.85,1.8a2.84,2.84,0,0,1,.21,1,2.57,2.57,0,0,1-.24,1.06,12.39,12.39,0,0,1-1.22,1.83,2.89,2.89,0,0,0-.67,2,9.34,9.34,0,0,0,.77,2.16,3.36,3.36,0,0,1,.24,1.18,2.69,2.69,0,0,1-.3,1.15,10,10,0,0,1-1.38,1.81,5.12,5.12,0,0,0-1.12,1.81,17.18,17.18,0,0,1-.66,2,2.45,2.45,0,0,1-.65.81,3,3,0,0,1-.91.43c-.3.11-.61.19-.88.32a3.21,3.21,0,0,0-.74.5,6.41,6.41,0,0,0-1,1.37c-.29.48-.57.95-.87,1.37a4.43,4.43,0,0,1-2.23,1.64,4.8,4.8,0,0,1-2.09.2,4.42,4.42,0,0,1-1.28-.37,4.06,4.06,0,0,1-.4-.23,5.17,5.17,0,0,0,1.69.52,4.75,4.75,0,0,0,2-.22,4.4,4.4,0,0,0,2.16-1.62c.29-.42.56-.88.85-1.37a6.36,6.36,0,0,1,1.07-1.4,2.86,2.86,0,0,1,.78-.54,7.48,7.48,0,0,1,.9-.33,2.91,2.91,0,0,0,.85-.41,2.21,2.21,0,0,0,.6-.75,15.68,15.68,0,0,0,.64-2,5.55,5.55,0,0,1,1.15-1.88,9.64,9.64,0,0,0,1.35-1.77,2.34,2.34,0,0,0,.28-1.07,3,3,0,0,0-.22-1.1,9.38,9.38,0,0,1-.79-2.21,2.41,2.41,0,0,1,.16-1.16,4.75,4.75,0,0,1,.55-1,12.6,12.6,0,0,0,1.21-1.8,2.56,2.56,0,0,0,.23-1,2.71,2.71,0,0,0-.2-1c-.23-.63-.58-1.2-.83-1.8a2.47,2.47,0,0,1-.17-1.88c.21-.59.61-1,.8-1.56a1.67,1.67,0,0,0-.14-1.49c-.24-.44-.55-.82-.8-1.22a2.62,2.62,0,0,1-.46-1.24,4,4,0,0,1,.19-1.14,3.66,3.66,0,0,0,.15-.93,1.39,1.39,0,0,0-.58-1.1A.83.83,0,0,0,139.64,172.47Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M115.21,193.2a.87.87,0,0,1,1.1-.48l4,1.47.45.17a10.18,10.18,0,0,1-.89,2.34,2.53,2.53,0,0,1-1.73,1.23,2.79,2.79,0,0,1-1.69-.42,3.3,3.3,0,0,1-1.78-2A4.93,4.93,0,0,1,115.21,193.2Z"
        style={{
          fill: "#6f4439",
        }}
      />
      <path
        d="M93.44,193.14a3.24,3.24,0,0,0-1,.55,4.34,4.34,0,0,0-1.56,2.56,4.69,4.69,0,0,0,0,2.1,5.36,5.36,0,0,0,3.4,3.56,4.77,4.77,0,0,0,2.85.06,5.14,5.14,0,0,0,2.44-1.48,4.65,4.65,0,0,0,1.16-2.4,4.94,4.94,0,0,0-1.25-4.2,4.3,4.3,0,0,0-1.46-.94,4.53,4.53,0,0,0-1.26-.33,2.63,2.63,0,0,0-.83,0,1.58,1.58,0,0,0-.27.08,3.7,3.7,0,0,1,1.09,0,4.89,4.89,0,0,1,1.22.36,4.58,4.58,0,0,1,1.38.94,4.8,4.8,0,0,1,1.16,4.05,4.44,4.44,0,0,1-1.12,2.26,5,5,0,0,1-2.32,1.42,4.63,4.63,0,0,1-2.71-.05,5.17,5.17,0,0,1-2.14-1.39,5,5,0,0,1-1.14-2,4.46,4.46,0,0,1-.08-2,4.29,4.29,0,0,1,1.45-2.51A8.48,8.48,0,0,1,93.44,193.14Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M114.65,184.89a1.38,1.38,0,0,1-1.27,1.46,1.33,1.33,0,0,1-1.49-1.19,1.4,1.4,0,0,1,1.28-1.46A1.33,1.33,0,0,1,114.65,184.89Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M128,184.55a1.39,1.39,0,0,1-1.27,1.46,1.34,1.34,0,0,1-1.49-1.19,1.39,1.39,0,0,1,1.28-1.46A1.32,1.32,0,0,1,128,184.55Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M127.44,179.44c-.13.21-1.2-.51-2.56-.36s-2.26,1-2.43.87,0-.44.42-.85a3,3,0,0,1,1.92-.94,3.15,3.15,0,0,1,2.07.52C127.32,179,127.51,179.34,127.44,179.44Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M114.41,180.56c-.19.21-1.35-.69-3-.68s-2.84.9-3,.69.1-.48.62-.89a3.94,3.94,0,0,1,4.8,0C114.33,180.08,114.5,180.46,114.41,180.56Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M119.06,197.43a1,1,0,0,1-.44.33,2.54,2.54,0,0,1-1.49.12,4,4,0,0,1-2-1,2.46,2.46,0,0,1-.67-1.19,3.19,3.19,0,0,1,0-1.44,5.85,5.85,0,0,1,.51-1.31,1,1,0,0,1,.58-.55,1.13,1.13,0,0,1,.72.12l2,.8a8.12,8.12,0,0,1,1.79.85,9.44,9.44,0,0,1-1.9-.56l-2-.72c-.41-.17-.6-.14-.79.25a6.83,6.83,0,0,0-.46,1.22,2.28,2.28,0,0,0,.5,2.25,3.77,3.77,0,0,0,1.74,1,2.6,2.6,0,0,0,1.36,0C118.87,197.51,119,197.4,119.06,197.43Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M145.78,152.76a8.07,8.07,0,0,0-1.75-1,6,6,0,0,0-2.3-.41,5.71,5.71,0,0,0-2.93.84l-.13.09-.09-.14a5.27,5.27,0,0,0-3.2-2.36,5.36,5.36,0,0,0-4.5.72l-.17.12-.12-.17a8.59,8.59,0,0,0-5.47-3.31,8.18,8.18,0,0,0-5,.75,8.6,8.6,0,0,0-3.47,3.07l0,.09h-.11a13.11,13.11,0,0,0-5.16,1.28,13.55,13.55,0,0,0-3.44,2.35,19.24,19.24,0,0,0-2.35,2.84s0-.08.1-.23.19-.37.36-.63a12.36,12.36,0,0,1,1.73-2.15,13.29,13.29,0,0,1,3.46-2.47,13.09,13.09,0,0,1,5.29-1.38l-.16.09A8.84,8.84,0,0,1,120,147.5a8.55,8.55,0,0,1,5.24-.8,9,9,0,0,1,5.73,3.5l-.29,0a5.71,5.71,0,0,1,4.85-.74,5.58,5.58,0,0,1,3.38,2.56l-.22-.06a5.84,5.84,0,0,1,3.09-.82,6,6,0,0,1,2.37.49,5.72,5.72,0,0,1,1.31.8A1.8,1.8,0,0,1,145.78,152.76Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M102.43,150.53a3.85,3.85,0,0,1-1.6.38,5.79,5.79,0,0,1-4.21-1.5,5.44,5.44,0,0,1-1.56-2.77,6,6,0,0,1,.36-3.65,5.42,5.42,0,0,1,2.93-2.81,5.85,5.85,0,0,1,4.41,0l-.25.06a4.1,4.1,0,0,1,2.4-1.37,4.33,4.33,0,0,1,2.34.2,3.86,3.86,0,0,1,1.77,1.44,4.24,4.24,0,0,1,.36,4.15l-.28-.26a3.52,3.52,0,0,1,3.29-.07,3.66,3.66,0,0,1,2,2.29,4.65,4.65,0,0,1-1.28,4.6,5.8,5.8,0,0,1-2.82,1.47,6.24,6.24,0,0,1-.84.11h-.3s.4,0,1.11-.23a5.93,5.93,0,0,0,2.68-1.51,4.41,4.41,0,0,0,1.12-4.33,3.28,3.28,0,0,0-1.78-2,3.12,3.12,0,0,0-2.92.07l-.59.35.3-.61a3.89,3.89,0,0,0-.35-3.75,3.47,3.47,0,0,0-1.58-1.27,3.81,3.81,0,0,0-2.09-.17,3.64,3.64,0,0,0-2.16,1.22l-.1.12-.15-.06a5.38,5.38,0,0,0-4.08,0,5,5,0,0,0-2.74,2.59,5.61,5.61,0,0,0-.37,3.42,5.07,5.07,0,0,0,1.42,2.63,5.72,5.72,0,0,0,4,1.55A8.36,8.36,0,0,0,102.43,150.53Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M72,167.16a1,1,0,0,1-.12-.25,5.59,5.59,0,0,1-.25-.74,6.89,6.89,0,0,1-.07-2.94,6.74,6.74,0,0,1,2.24-3.87,7.13,7.13,0,0,1,5.4-1.64l-.22.11a8.52,8.52,0,0,1,4.31-4.06,8.22,8.22,0,0,1,4.49-.52,8.42,8.42,0,0,1,3.79,1.65l-.21,0a9.37,9.37,0,0,1,4.55-1.09,9.67,9.67,0,0,1,3.57.73,8.58,8.58,0,0,1,2,1.18,3.4,3.4,0,0,1,.61.57,12.78,12.78,0,0,0-2.74-1.53,9.67,9.67,0,0,0-3.48-.62,9.06,9.06,0,0,0-4.36,1.1l-.11.06-.11-.08a8.16,8.16,0,0,0-3.62-1.53,7.82,7.82,0,0,0-4.25.5,8.11,8.11,0,0,0-4.1,3.84l-.07.14-.15,0a6.79,6.79,0,0,0-5.11,1.5,6.52,6.52,0,0,0-2.21,3.65,7.09,7.09,0,0,0,0,2.86C71.91,166.8,72.05,167.15,72,167.16Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M185.91,285.74l-3.61-5.45-5.78-2.9-.22-.16a7.76,7.76,0,0,0-6.55-1.22c-2.36.63-5.5,1.41-8.23,1.88l-6.22-1.71v12.15l31.39-2Z"
        style={{
          fill: "#ae7461",
        }}
      />
      <path
        d="M185.69,285.41a8.23,8.23,0,0,0-1.33-1.21c-.85-.71-2-1.67-3.37-2.71l-1.24-1,0,0h0c-1.29-.24-2.41-.43-3.21-.56a5.42,5.42,0,0,0-1.28-.13,4.64,4.64,0,0,0,1.24.37c.78.19,1.89.43,3.17.69l-.08,0,1.24,1c1.33,1,2.55,2,3.44,2.62A8.14,8.14,0,0,0,185.69,285.41Z"
        style={{
          fill: "#6f4439",
        }}
      />
      <path
        d="M183.24,286.47a35,35,0,0,0-4.51-2.73l-1.1-.6,0,0h0a24.44,24.44,0,0,0-4-.07,25.24,25.24,0,0,0,4,.44l-.08,0,1.1.61A37,37,0,0,0,183.24,286.47Z"
        style={{
          fill: "#6f4439",
        }}
      />
      <path
        d="M222.44,251.38a2.38,2.38,0,0,0-3.09.66l-25.28,34.24-40,.54c-1.59.1-3.53,3.33-2.1,4.89l45.17-.62,26.08-36.23A2.39,2.39,0,0,0,222.44,251.38Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M101.26,211.72a13.36,13.36,0,0,0-6.72,3.14,22.68,22.68,0,0,0-5.38,8.82c-1.34,4-.74,19.81-.74,24.39s1.17,21.78,1.74,24.64-.37,7.12-1.69,9.88c-2.38,5,1.33,7.51,1.33,7.51l49.08-.36-.19-1.84c-.34-3.19.85-6.43-.37-9.4a30.6,30.6,0,0,1-2.26-13.76c.63-8.18,3.07-13.76,1.57-18.5-2.29-7.24-9.85-23.7-19-30.73,0,0-7.2-1.54-8.83-2.11C106.11,212.1,104.15,211.4,101.26,211.72Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M159,274.77,117,266,116,229.61s-1.47-14.83-8.9-16.21l-17.9,22.28c1,11.23.09,32.48,5.25,40.67s10.18,14.76,22.89,14.18,40.71-.85,40.71-.85Z"
        style={{
          fill: theme.imageHighlight,
        }}
      />
      <path
        d="M117.12,266.16c.1.08-.9,1.39-1.75,3.22s-1.22,3.44-1.34,3.41a8,8,0,0,1,1-3.59A8.21,8.21,0,0,1,117.12,266.16Z"
        style={{
          fill: theme.text,
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M115.67,228.05c4.19,12.88,3.28,32.72,11.27,40L117,266a50.4,50.4,0,0,0,.08-7c-.8-10.18-.9-20.53-1.45-31" />
      </g>
      <path
        d="M114.74,223.46a23.12,23.12,0,0,1,.73,2.92A35.52,35.52,0,0,1,116,230c.14,1.43.16,3.08.23,4.93.24,7.43.58,18.1,1,31.09l-.14-.16,42,8.72.18,0,0,.18c-.3,4.77-.63,9.79-1,14.9v.2H158l-5.1.06c-7.29.09-14.4.2-21.27.35q-5.16.1-10.11.27c-3.29.08-6.56.39-9.72-.1a21.22,21.22,0,0,1-4.56-1.18,19.38,19.38,0,0,1-4-2.2,27.42,27.42,0,0,1-6-6.28c-.81-1.15-1.59-2.3-2.31-3.44l-.55-.86c-.17-.29-.32-.59-.48-.89l-.47-.89-.36-.92a34.84,34.84,0,0,1-1.87-7.28,111,111,0,0,1-1.23-12.84c-.19-3.79-.28-7.05-.37-9.72s-.18-4.74-.25-6.15c0-.69-.08-1.22-.1-1.59s0-.55,0-.55,0,.18.06.54.08.91.14,1.6c.1,1.4.23,3.47.34,6.14s.22,5.93.44,9.72a113.32,113.32,0,0,0,1.28,12.8,35.22,35.22,0,0,0,1.88,7.21l.36.91.46.86c.16.29.31.59.48.87l.54.85c.73,1.14,1.5,2.28,2.32,3.42a26.94,26.94,0,0,0,6,6.19,19.05,19.05,0,0,0,4,2.15,20.94,20.94,0,0,0,4.47,1.14c3.11.48,6.34.17,9.65.08s6.68-.2,10.12-.28c6.87-.15,14-.27,21.28-.36l5.1,0-.21.19c.33-5.11.66-10.13,1-14.9l.16.22L117,266.19l-.14,0V266c-.36-13-.65-23.66-.85-31.09-.06-1.85-.06-3.51-.18-4.93s-.29-2.63-.46-3.6-.35-1.7-.47-2.19c0-.24-.1-.42-.13-.56S114.74,223.46,114.74,223.46Z"
        style={{
          fill: theme.text,
        }}
      />
      <polygon
        points="182.05 364.14 175.83 410.01 192.12 412.68 203.7 371.98 182.05 364.14"
        style={{
          fill: "#ae7461",
        }}
      />
      <path
        d="M132.67,293.65s59.53-3.91,71.89-1.94c7.47,1.19,13.91,12.86,9.84,19.88-1.93,3.32-5,13.66-5,13.66l-32-7.3Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <polygon
        points="177.44 325.25 164.55 344.92 179.72 354.75 196.18 329.52 177.44 325.25"
        style={{
          fill: "#ae7461",
        }}
      />
      <path
        d="M91,290.05s-6.29,27.73,3.86,38.63c7.24,7.77,25,6.95,40,6.95,15.17,0,50.21-.83,50.21-.83s-1.59,9.75-2.75,20.85-1.41,18.12-1.41,18.12l22.33,1.86s12.44-37.86,14.35-45.36,1.27-17.57-5.35-21.31c-5.6-3.16-49.83-15.43-71-17.25l-2.3-2Z"
        style={{
          fill: theme.compImgHighlight,
        }}
      />
      <path
        d="M195.93,325.69c0,.07-.86.2-2.19.67a13.87,13.87,0,0,0-2.23,1,15.46,15.46,0,0,0-2.43,1.76,16.3,16.3,0,0,0-2,2.24,13.94,13.94,0,0,0-1.26,2.12c-.61,1.27-.82,2.13-.9,2.11A1.9,1.9,0,0,1,185,335a9.85,9.85,0,0,1,.53-1.62,12.86,12.86,0,0,1,1.22-2.21,13.16,13.16,0,0,1,4.57-4.12,11.71,11.71,0,0,1,2.33-1,9.21,9.21,0,0,1,1.66-.37A1.73,1.73,0,0,1,195.93,325.69Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M193.28,302.82a6.45,6.45,0,0,1,1.18-2.31,6.2,6.2,0,0,1,1.72-1.94,11.23,11.23,0,0,1-1.37,2.18A10.88,10.88,0,0,1,193.28,302.82Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M218.47,319.73a.64.64,0,0,1-.06-.21c0-.17-.09-.38-.16-.64-.13-.56-.33-1.38-.67-2.41a18.22,18.22,0,0,0-1.58-3.61,9,9,0,0,0-3.61-3.62,97.74,97.74,0,0,0-12.86-4.58c-4.94-1.47-10.39-3-16.13-4.56-11.5-3.05-22.05-5.24-29.74-6.51-3.84-.65-7-1.09-9.13-1.4l-2.48-.33-.65-.1a1.15,1.15,0,0,1-.22-.05h.23l.65,0,2.49.26c2.17.25,5.3.65,9.16,1.26a300.4,300.4,0,0,1,29.79,6.4c5.76,1.52,11.21,3.1,16.14,4.6A93.84,93.84,0,0,1,212.53,309a9.23,9.23,0,0,1,3.67,3.77,17.34,17.34,0,0,1,1.54,3.68c.31,1.05.49,1.88.6,2.44,0,.27.08.48.11.65A.73.73,0,0,1,218.47,319.73Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M193.38,411.49l.54-2a30.94,30.94,0,0,1-18-7.75l-5.52,11.93,36.8,16.37C208.62,426.53,193.38,411.49,193.38,411.49Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M170.43,413.68l1.35-2.91,34.85,16.81s1.32,1.43.6,2.47Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M192.89,411.26c-.09.17-1-.15-2.17,0s-2,.7-2.1.55.61-1,2-1.21S193,411.11,192.89,411.26Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M178.57,410a1.09,1.09,0,0,1-1.42.49,1,1,0,0,1-.5-1.38,1.07,1.07,0,0,1,1.42-.49A1,1,0,0,1,178.57,410Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M192.67,411a2.21,2.21,0,0,1-.84-.15,4.44,4.44,0,0,1-2.06-1.1,3.15,3.15,0,0,1-.48-.64,1.91,1.91,0,0,1-.31-.84.9.9,0,0,1,.58-.91,1.38,1.38,0,0,1,1.11.05A4.11,4.11,0,0,1,193,411l-.55-.08a4.24,4.24,0,0,1,.37-.82,4.53,4.53,0,0,1,4-2.26,1.34,1.34,0,0,1,.62.12.76.76,0,0,1,.41.55,1.4,1.4,0,0,1-.26,1.06,3.25,3.25,0,0,1-1.41,1.13,5.71,5.71,0,0,1-2.53.38,3.12,3.12,0,0,1-.92-.08,3,3,0,0,1,.91-.13,6.37,6.37,0,0,0,2.37-.51,3.07,3.07,0,0,0,1.19-1,1,1,0,0,0,.18-.72c0-.2-.23-.27-.57-.27a4.06,4.06,0,0,0-3.5,2,4.54,4.54,0,0,0-.32.72.28.28,0,0,1-.54-.07,3.68,3.68,0,0,0-1.93-3.16c-.5-.26-1.08,0-1,.4a2.39,2.39,0,0,0,.62,1.25,4.82,4.82,0,0,0,1.85,1.16A3.63,3.63,0,0,1,192.67,411Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M195.71,413.81a15.09,15.09,0,0,0-2.43.17,13.48,13.48,0,0,0-2.23,1,3.84,3.84,0,0,1,4.66-1.16Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M197.77,416.15c0,.12-1,.09-2.16.44s-2,.9-2.05.8a3.26,3.26,0,0,1,1.93-1.21A3.21,3.21,0,0,1,197.77,416.15Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M182.61,352.53l.87-1.87A31,31,0,0,1,167.06,340l-7.45,10.83,33.53,22.33C195.1,369.92,182.61,352.53,182.61,352.53Z"
        style={{
          fill: theme.text,
        }}
      />
      <path
        d="M159.61,350.83l1.82-2.65L193,370.63s1,1.62.18,2.53Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M182.16,352.22c-.12.15-1-.32-2.14-.34s-2.06.35-2.16.19.77-.92,2.17-.86S182.3,352.1,182.16,352.22Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M168.26,348.55a1.08,1.08,0,0,1-1.48.24,1,1,0,0,1-.26-1.44,1.08,1.08,0,0,1,1.48-.25A1,1,0,0,1,168.26,348.55Z"
        style={{
          fill: "#e0e0e0",
        }}
      />
      <path
        d="M182,351.94a2.33,2.33,0,0,1-.79-.29,4.52,4.52,0,0,1-1.85-1.43,2.81,2.81,0,0,1-.37-.71,1.89,1.89,0,0,1-.16-.89.91.91,0,0,1,.72-.8,1.44,1.44,0,0,1,1.09.24,4.11,4.11,0,0,1,1.64,3.93l-.52-.17a4.46,4.46,0,0,1,.49-.76,4.55,4.55,0,0,1,4.32-1.55,1.33,1.33,0,0,1,.58.23.77.77,0,0,1,.32.6,1.38,1.38,0,0,1-.44,1,3.24,3.24,0,0,1-1.58.87,5.65,5.65,0,0,1-2.55-.05,3.41,3.41,0,0,1-.9-.23,2.93,2.93,0,0,1,.93,0,6.15,6.15,0,0,0,2.41-.1,2.94,2.94,0,0,0,1.35-.82,1,1,0,0,0,.3-.67c0-.22-.18-.31-.51-.37a4.07,4.07,0,0,0-3.79,1.41,4.38,4.38,0,0,0-.44.65.27.27,0,0,1-.37.12.26.26,0,0,1-.15-.28,3.7,3.7,0,0,0-1.37-3.44c-.45-.34-1.06-.21-1.09.22a2.45,2.45,0,0,0,.4,1.34,4.69,4.69,0,0,0,1.64,1.45A3.12,3.12,0,0,1,182,351.94Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M184.51,355.21a14.19,14.19,0,0,0-2.42-.24,14,14,0,0,0-2.37.6,3.84,3.84,0,0,1,4.79-.36Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M186.14,357.86c0,.12-1-.08-2.2.07s-2.09.56-2.15.45a4.21,4.21,0,0,1,4.35-.52Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
  </svg>
    );
  }
}